import { render, staticRenderFns } from "./p19.vue?vue&type=template&id=3f8f6ebb&scoped=true&"
import script from "./p19.vue?vue&type=script&lang=js&"
export * from "./p19.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8f6ebb",
  null
  
)

export default component.exports